import React from "react";
import { useTranslation } from "react-i18next";
import "./loader.css"

const Loader = ({ show }) => {
  const { t } = useTranslation();
  return <section className={show ? "section-loader show-loader" : "section-loader  hidden-loader"}>
    <div className="container-loader">
      <div className="loader"></div>
      <h3 style={{color:"#e5383b"}} className="my-2">{t('waiting')}</h3>
    </div>
  </section>
}

export default Loader;